import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MelbournesReliableSparkies from "./sections/MelbournesReliableSparkies";
import OurTrustPillars from "./sections/OurTrustPillars";
import ExpertiseAtAGlance from "./sections/ExpertiseAtAGlance";
import YourLocalNararaPlumber from "./sections/YourLocalNararaPlumber";
import ServicingNararaSurroundingAreas from "./sections/ServicingNararaSurroundingAreas";
import BrandFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <MelbournesReliableSparkies />
      <OurTrustPillars />
      <ExpertiseAtAGlance />
      <YourLocalNararaPlumber />
      <ServicingNararaSurroundingAreas />
      <BrandFooter />
    </div>;
}